import React, {useState, useEffect} from "react";
import { useParams, Link } from "react-router-dom";
import {Tabs, Tab} from "react-bootstrap";
import moment from "moment";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
//import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";

import {getProfileInfoAPI} from "./../../API/Sales/LeadAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
//import PieChart from "../../utils/Charts/PieChart";


const LeadProfile = () =>{

    const {leadid} = useParams();
    const current = moment();

	const [btnloading, setBtnLoading] = useState(false);
	const [activetabs, setActiveTabs] = useState("activities");
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [contact, setContact] = useState("");
	const [location, setLocation] = useState("");
	const [stage, setStage] = useState("");
	const [disposition, setDisposition] = useState("");
	const [subdisposition, setSubDisposition] = useState("");
	const [otheremail, setOtherEmail] = useState("");
	const [othercontact, setOtherContact] = useState("");
	const [program, setProgram] = useState("");
	const [institute, setInstitute] = useState("");
	const [source, setSource] = useState("");
	const [createddate, setCreatedDate] = useState("");
	const [lastupdated, setLastUpdated] = useState("");
	const [remarks, setRemarks] = useState([]);
	const [pipeline, setPipeline] = useState([]);

    useEffect(()=>{

        getProfileInfoAPI(setName, setEmail, setContact, setLocation, setStage, setDisposition, setSubDisposition, setOtherEmail, setOtherContact, setProgram, setInstitute, setSource, setCreatedDate, setLastUpdated, setRemarks, setPipeline, leadid);

    }, [])



    return(
    <div className="main-wrapper">

        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
			<div className="content">

				<div className="row">
					<div className="col-md-12">

						<div className="page-header">
							<div className="row align-items-center">
								<div className="col-sm-4">
									<h4 className="page-title">Leads Overview </h4>
								</div>
								<div className="col-sm-8 text-sm-end">
									<div className="head-icons">
										
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div className="row">
					<div className="col-md-12">

						<div className="contact-head">
							<div className="row align-items-center">
								<div className="col-sm-6">
									<ul className="contact-breadcrumb">
										<li>
                                            <Link href="leads.html">
                                                <i className="ti ti-arrow-narrow-left"></i>Leads
                                            </Link>
                                        </li>
										<li>{name}</li>
									</ul>
								</div>
								<div className="col-sm-6 text-sm-end">
									<div className="contact-pagination">
										
									</div>
								</div>
							</div>
						</div>
						<div className="card">
							<div className="card-body pb-2">
								<div className="d-flex align-items-center justify-content-between flex-wrap">
									<div className="d-flex align-items-center mb-2">
										<div className="avatar avatar-xxl me-3 flex-shrink-0 border p-2">
											<h6 className="text-default fw-medium">HT</h6>
										</div>
										<div>
											<h5 className="mb-1 fs-16">{name} 
												<span className="star-icon">
													<i className="fa-solid fa-star"></i>
												</span>
											</h5>
											<p className="mb-1">
												<i className="ti ti-mail me-1"></i>{email}
											</p>
											<p className="mb-1">
												<i className="ti ti-phone-call me-1"></i>{contact}
											</p>
											<p className="mb-0">
												<i className="ti ti-map-pin-pin me-1"></i>{location}
											</p>
										</div>
									</div>
									<div className="contacts-action">
										{stage !== "" && stage !== null && stage !== undefined ?
										<span className="badge badge-light bg-success"> {stage} </span>
										:
											<p></p>
										}
									</div>
								</div>
							</div>
						</div>

					</div>

					<div className="col-xl-3 theiaStickySidebar">
						<div className="card">
							<div className="card-body p-3">
								<h6 className="mb-3 fw-semibold">Lead Information</h6>
								<ul>
									<li className="row mb-3">
										<span className="col-6">Other Email</span>
										<span className="col-6">{otheremail}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Other Contact</span>
										<span className="col-6">{othercontact}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Program</span>
										<span className="col-6">{program}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Institute</span>
										<span className="col-6">{institute}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Lead Stage</span>
										<span className="col-6">{stage}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Disposition</span>
										<span className="col-6">{disposition}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Sub-Disposition</span>
										<span className="col-6">{subdisposition}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Source</span>
										<span className="col-6">{source}</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Date Created</span>
										<span className="col-6">{ moment(createddate).format('DD MMM YYYY') }</span>
									</li>
									<li className="row mb-3">
										<span className="col-6">Last Updated</span>
										<span className="col-6">{ moment(lastupdated).format('DD MMM YYYY') }</span>
									</li>

								</ul>
							</div>
						</div>
					</div>

					<div className="col-xl-9">

						<div className="card mb-3">
							<div className="card-body pb-0">
								<h4 className="fw-semibold mb-3">Lead Pipeline Status</h4>
								<div className="pipeline-list">
									<ul>
										<li>
											<Link to="" className="bg-pending">Not Contacted</Link>
										</li>
										<li>
											<Link to="" className="bg-info">Contacted</Link>
										</li>
										<li>
											<Link to="" className="bg-success">Closed</Link>
										</li>
										<li>
											<Link to="" className="bg-danger">Lost</Link>
										</li>
									</ul>
								</div>
								<ul className="nav nav-tabs nav-tabs-bottom" role="tablist">										
									<Tabs activeKey={activetabs} onSelect={(k) => setActiveTabs(k)} className="nav-tabs-bottom">
										<Tab eventKey="activities" title={<><i className="ti ti-alarm-minus me-1"></i> Activities</>}>
											
										</Tab>
										<Tab eventKey="email" title={<><i className="ti ti-mail-check me-1"></i>Email</>}>
											
										</Tab>
									</Tabs>
								</ul>
							</div>
						</div>

						<div className="tab-content pt-0">
							{ activetabs === 'activities' &&
							<div className="card">
								<div class="card remarks-timeline mb-30">
									<div class="title d-flex flex-wrap align-items-center justify-content-between mb-3">
										<div class="left">
											<h6 class="text-medium mb-30">Latest Remarks</h6>
										</div>
										<div class="right">
											
										</div>
									</div>
									<ul class="timeline-3">
										{remarks.map(remark =>
											(
											<li>
												<span className="remark-heading">{remark.name}</span>
												<span className="remark-date float-end">{moment(remark.created_at).format('DD MMM YYYY')} </span>
												<p class="mt-2">{remark.remarks}</p>
											</li>
											))
										}
										
										{/*<li>
											<span className="remark-heading">Shardha Sen</span>
											<span className="remark-date float-end">20 March, 2014</span>
											<p class="mt-2">No response, Mobile ringing, not picked</p>
										</li>*/}
									</ul>
								</div>
							</div>
							}

							{ activetabs === 'email' &&
							<div className="card">
								<div className="card border mb-0">
									<div className="card-body pb-0">
										<div className="row align-items-center">
											<div className="mb-3">
												<label className="form-label"> To</label>
												<input type="text" className="form-control" name="to" id="to" defaultValue='abc@gmail.com' readOnly />
											</div>
											<div className="mb-3">
												<label className="form-label"> Subject</label>
												<input type="text" className="form-control" name="subject" id="subject" />
											</div>
											<div className="mb-3">
												<label className="form-label"> Mail Content</label>
												<textarea className="form-control" name="mailtext" id="mailtext" rows={5} cols={50}></textarea>
											</div>
											<div className="mb-3">
												<div className="text-end">
													<button type="button" className="btn btn-primary">
														{btnloading ?
															<div className="spinner-border" role="status">
																<span className="sr-only">Loading...</span>
															</div>
														:
															<p>Send Mail</p>
														}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							}
						</div>
					</div>
				</div>

			</div>
		</div>
    </div>
    )
}

export default LeadProfile;